module.exports = __webpack_public_path__ + "static/media/10-video-popup.c7843a4c.png";